<div class="body">
	<div class="container">
		<div class="header">
			<h1>Data Privacy Removal Request</h1>
		</div>

		<p>
			Welcome to the Data Privacy Removal Request page for Simple Weekly Meal Planner. In accordance
			with the General Data Protection Regulation (GDPR) and other data privacy regulations, we
			respect your right to privacy and control over your personal data. This page guides you
			through the process of submitting a request for data deletion.
		</p>

		<h2>Your Rights</h2>
		<p>
			You have the right to request the deletion of your personal data that we hold. This is also
			known as the 'right to be forgotten'. When you request data deletion, we will remove your
			personal data from our systems, subject to any necessary exceptions required by law.
		</p>

		<h2>What Data We Collect</h2>

		<ul>
			<li>
				Account Information: Your name, email address, and other details provided during account
				creation.
			</li>
			<li>
				Usage Data: Information about how you interact with our app, such as meal plans created,
				preferences, and settings.
			</li>
		</ul>

		<h2>How to Request Data Deletion</h2>

		<ol>
			<li>
				Making the Request: Please email us at privacy@simpleweeklymealplanner.com with the subject
				line "Data Deletion Request."
			</li>
			<li>
				Details to Include: In your email, please provide your full name, email address associated
				with your account, and a brief statement of your request for data deletion.
			</li>
			<li>
				Processing Your Request: Once we receive your request, our team will review it and may
				contact you for further verification. We aim to process all requests within 30 days, in
				accordance with GDPR regulations.
			</li>
			<li>
				Confirmation: After your data has been deleted, we will send you a confirmation email.
			</li>
		</ol>

		<h2>Further Assistance</h2>
		<p>
			If you have any questions about this process or your rights under the GDPR, please contact our
			Data Protection Officer at dpo@simpleweeklymealplanner.com. Please Note: Deleting your data
			will result in the loss of access to any personalized features and saved data in the Simple
			Weekly Meal Planner app. We recommend backing up any important information before proceeding
			with your request. Thank you for using Simple Weekly Meal Planner.
		</p>
		<p><small>Created by Fonner Development</small></p>
	</div>
</div>

<style>
	.body {
		background: linear-gradient(to right, var(--gradient-start), var(--gradient-end));
		padding: 80px 20px;
		height: calc(100vh - 64px);
	}
	.container {
		max-width: 960px;
		margin: 0 auto;
		padding: 20px;
		background-color: var(--theme-on-primary);
		-webkit-box-shadow: 1px 1px 8px 3px #2d63b2;
		-moz-box-shadow: 1px 1px 8px 3px #2d63b2;
		box-shadow: 1px 1px 8px 3px #2d63b2;
	}

	.header {
		width: 100%;
		text-align: center;
		margin-bottom: 1rem;
		text-transform: uppercase;
	}

	h1 {
		font-size: 2.5rem;
		margin-bottom: 1rem;
	}

	h2 {
		font-size: 1.5rem;
		margin-bottom: 1rem;
	}

	p {
		font-size: 1.125rem;
		line-height: 1.5;
		margin-bottom: 1rem;
	}

	ul {
		padding-left: 1 rem;
	}

	li {
		margin-bottom: 0.5rem;
	}
</style>
